<template>
  <span class="role-badge" :class="badgeClass">
    {{ roleName }}
  </span>
</template>

<script>
import constants from '@/constants'
import roles from '@/translations/roles'

export default {
  name: 'UserRoleBadge',
  props: {
    role: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    roleNum() {
      return Number(this.role)
    },

    roleName() {
      const role = roles.find(item => Number(item.num) === this.roleNum)

      if (role) {
        return role?.name?.[this.$i18n.locale] || role?.name?.en || String(this.role)
      }

      return this.$t('Deprecated Role')
    },

    badgeClass() {
      const role = roles.find(item => Number(item.num) === this.roleNum)

      if (!role) {
        return 'deprecated'
      }

      const userRoles = constants.userRoles

      if (this.roleNum === userRoles.superAdmin) return 'red'
      if (this.roleNum === userRoles.owner) return 'dark-blue'
      if (this.roleNum === userRoles.admin) return 'blue'
      if (this.roleNum === userRoles.accountant) return 'purple'
      if (this.roleNum === userRoles.moderator) return 'orange'

      if (this.roleNum === userRoles.employeeMaster) {
        return 'green'
      }

      return 'deprecated'
    },
  },
}
</script>